import * as React from 'react';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';
import { trackOpenContacts, trackShowPhone } from './tracking';
import { getBuilders, getGaLabel, getSellers } from '../../selectors/newbuilding';
import { TShowPhoneAction } from '../../types/analytics/call';
import { CallButton } from '../CallButton';

export interface IHeaderCallProps {
  placeType?: string;
  eventAction: TShowPhoneAction;
}

const CALL_BUTTON_STYLES = {
  size: 'M' as const,
  beforeIcon: <IconCommunicationPhone16 color="icon-inverted-default" />,
};

export const HeaderCall = ({ placeType = 'blockFicheringStickyHeader', eventAction }: IHeaderCallProps) => {
  const gaLabel = useSelector(getGaLabel);
  const builders = useSelector(getBuilders);
  const sellers = useSelector(getSellers);

  const isLeadFactory = sellers.find(seller => seller.isLeadFactory);
  const isBuildersWithPhones = builders.filter(builder => builder.phone?.number && builder.showPhone).length > 0;

  const buttonText = isLeadFactory
    ? 'Контакты консультанта'
    : isBuildersWithPhones
      ? 'Контакты застройщика'
      : 'Контакты продавца';

  const onShowPhoneClick = React.useCallback(() => {
    trackShowPhone(gaLabel, eventAction);
  }, [gaLabel, eventAction]);

  const onOpenContactsClick = React.useCallback(() => {
    trackOpenContacts(gaLabel);
  }, [gaLabel]);

  return (
    <CallButton
      placeType={placeType}
      onOpenContactsClick={onOpenContactsClick}
      onShowPhoneClick={onShowPhoneClick}
      openContactsStyles={CALL_BUTTON_STYLES}
      showPhoneStyles={CALL_BUTTON_STYLES}
      singlePhoneButtonText={buttonText}
      multiplePhoneButtonText={buttonText}
    />
  );
};

HeaderCall.displayName = 'GalleryCall';
